<template>
	<TechnologySection>
		<template #heading>
			Your returns are <br />
			maximized through our end-to-end technology
		</template>
		<template #content>
			<p class="body-lg mt-250-md mt-150-smo">
				While historically profitable, the private market investing industry is notorious for its high fees,
				misaligned incentives, and near-total lack of technological innovation. Fundrise investors, on the other
				hand, are arguably able to own private market assets in a more low-cost way than was previously ever
				possible.
			</p>
			<p class="body-lg mt-150 mb-50-md">
				We've redesigned each step of the investment management process, replacing high-cost manual workflows
				with software-enabled automated systems. The result is a single integrated platform designed to deliver
				better net performance potential.
			</p>
		</template>
		<template #list>
			<HowItWorksTechnologyList />
		</template>
	</TechnologySection>
</template>

<script setup lang="ts">
import HowItWorksTechnologyList from '@components/marketing-site/how-it-works/how-it-works-technology-list.vue';
import TechnologySection from '@components/marketing-site/technology-section.vue';
</script>
